"use client";

import { c as _c } from "react/compiler-runtime";
import * as React from "react";
import { useId, useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { cn } from "../../../utils";
import type { VariantProps, SvgProps } from "../../color-block.types";
function RectangleXlSvg(t0) {
  const $ = _c(270);
  const {
    color,
    animated,
    shapeScale
  } = t0;
  const id = useId();
  let t1;
  if ($[0] !== animated || $[1] !== shapeScale) {
    t1 = origin => ({
      scale: animated ? shapeScale : 1,
      transformOrigin: origin
    });
    $[0] = animated;
    $[1] = shapeScale;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const style = t1;
  switch (color) {
    case "bright-blue":
      {
        const t2 = `${id}-bright-blue`;
        let t3;
        if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
          t3 = <rect width="1440" height="1275" fill="white" />;
          $[3] = t3;
        } else {
          t3 = $[3];
        }
        let t4;
        if ($[4] !== t2) {
          t4 = <defs><clipPath id={t2}>{t3}</clipPath></defs>;
          $[4] = t2;
          $[5] = t4;
        } else {
          t4 = $[5];
        }
        const t5 = `url(#${id}-bright-blue)`;
        let t6;
        if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
          t6 = <rect width="1440" height="1275" fill="#5375CF" />;
          $[6] = t6;
        } else {
          t6 = $[6];
        }
        let t7;
        if ($[7] !== style) {
          t7 = <motion.path opacity={0.4} d="M1542 1314H901V682.959C901 506.211 1044.52 363 1221.46 363C1398.4 363 1542 506.293 1542 682.959V1314Z" fill="#4668C2" style={style("bottom right")} />;
          $[7] = style;
          $[8] = t7;
        } else {
          t7 = $[8];
        }
        let t8;
        if ($[9] !== style) {
          t8 = <motion.path opacity={0.7} d="M-66.5 958L-66.5 317L580.541 317C757.289 317 900.5 460.517 900.5 637.459C900.5 814.4 757.207 958 580.541 958L-66.5 958Z" fill="#4668C2" style={style("center left")} />;
          $[9] = style;
          $[10] = t8;
        } else {
          t8 = $[10];
        }
        let t9;
        if ($[11] !== style) {
          t9 = <motion.path opacity={0.4} d="M-66.5 1599L-66.5 958L580.541 958C757.289 958 900.5 1101.52 900.5 1278.46C900.5 1455.4 757.207 1599 580.541 1599L-66.5 1599Z" fill="#4668C2" style={style("bottom left")} />;
          $[11] = style;
          $[12] = t9;
        } else {
          t9 = $[12];
        }
        let t10;
        if ($[13] !== style) {
          t10 = <motion.path opacity={0.7} d="M622 -215L1263 -215L1263 105.541C1263 282.565 1119.48 426 942.541 426C765.6 426 622 282.483 622 105.541L622 -215Z" fill="#4668C2" style={style("top right")} />;
          $[13] = style;
          $[14] = t10;
        } else {
          t10 = $[14];
        }
        let t11;
        if ($[15] !== t10 || $[16] !== t5 || $[17] !== t7 || $[18] !== t8 || $[19] !== t9) {
          t11 = <g clipPath={t5}>{t6}{t7}{t8}{t9}{t10}</g>;
          $[15] = t10;
          $[16] = t5;
          $[17] = t7;
          $[18] = t8;
          $[19] = t9;
          $[20] = t11;
        } else {
          t11 = $[20];
        }
        let t12;
        if ($[21] !== t11 || $[22] !== t4) {
          t12 = <svg className="absolute inset-0 h-full w-full" viewBox="0 0 1440 1275" fill="none" preserveAspectRatio="xMidYMid slice" aria-hidden="true">{t4}{t11}</svg>;
          $[21] = t11;
          $[22] = t4;
          $[23] = t12;
        } else {
          t12 = $[23];
        }
        return t12;
      }
    case "light-green":
      {
        const t2 = `${id}-light-green`;
        let t3;
        if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
          t3 = <rect width="1440" height="1275" fill="white" />;
          $[24] = t3;
        } else {
          t3 = $[24];
        }
        let t4;
        if ($[25] !== t2) {
          t4 = <defs><clipPath id={t2}>{t3}</clipPath></defs>;
          $[25] = t2;
          $[26] = t4;
        } else {
          t4 = $[26];
        }
        const t5 = `url(#${id}-light-green)`;
        let t6;
        if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
          t6 = <rect width="1440" height="1275" fill="#9BD7D2" />;
          $[27] = t6;
        } else {
          t6 = $[27];
        }
        let t7;
        if ($[28] !== style) {
          t7 = <motion.path opacity={0.7} d="M1542 1328.5H901V682.959C901 506.211 1044.52 363 1221.46 363C1398.4 363 1542 506.293 1542 682.959V1328.5Z" fill="#85CDC7" style={style("bottom right")} />;
          $[28] = style;
          $[29] = t7;
        } else {
          t7 = $[29];
        }
        let t8;
        if ($[30] !== style) {
          t8 = <motion.path opacity={0.7} d="M-66.5 958L-66.5 317L580.541 317C757.289 317 900.5 460.517 900.5 637.459C900.5 814.4 757.207 958 580.541 958L-66.5 958Z" fill="#85CDC7" style={style("center left")} />;
          $[30] = style;
          $[31] = t8;
        } else {
          t8 = $[31];
        }
        let t9;
        if ($[32] !== style) {
          t9 = <motion.path opacity={0.4} d="M-66.5 1599L-66.5 958L580.541 958C757.289 958 900.5 1101.52 900.5 1278.46C900.5 1455.4 757.207 1599 580.541 1599L-66.5 1599Z" fill="#85CDC7" style={style("bottom left")} />;
          $[32] = style;
          $[33] = t9;
        } else {
          t9 = $[33];
        }
        let t10;
        if ($[34] !== style) {
          t10 = <motion.path opacity={0.4} d="M622 -215L1263 -215L1263 105.541C1263 282.565 1119.48 426 942.541 426C765.6 426 622 282.483 622 105.541L622 -215Z" fill="#85CDC7" style={style("top right")} />;
          $[34] = style;
          $[35] = t10;
        } else {
          t10 = $[35];
        }
        let t11;
        if ($[36] !== t10 || $[37] !== t5 || $[38] !== t7 || $[39] !== t8 || $[40] !== t9) {
          t11 = <g clipPath={t5}>{t6}{t7}{t8}{t9}{t10}</g>;
          $[36] = t10;
          $[37] = t5;
          $[38] = t7;
          $[39] = t8;
          $[40] = t9;
          $[41] = t11;
        } else {
          t11 = $[41];
        }
        let t12;
        if ($[42] !== t11 || $[43] !== t4) {
          t12 = <svg className="absolute inset-0 h-full w-full" viewBox="0 0 1440 1275" fill="none" preserveAspectRatio="xMidYMid slice" aria-hidden="true">{t4}{t11}</svg>;
          $[42] = t11;
          $[43] = t4;
          $[44] = t12;
        } else {
          t12 = $[44];
        }
        return t12;
      }
    case "turquoise":
      {
        const t2 = `${id}-turquoise`;
        let t3;
        if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
          t3 = <rect width="1440" height="1275" fill="white" />;
          $[45] = t3;
        } else {
          t3 = $[45];
        }
        let t4;
        if ($[46] !== t2) {
          t4 = <defs><clipPath id={t2}>{t3}</clipPath></defs>;
          $[46] = t2;
          $[47] = t4;
        } else {
          t4 = $[47];
        }
        const t5 = `url(#${id}-turquoise)`;
        let t6;
        if ($[48] === Symbol.for("react.memo_cache_sentinel")) {
          t6 = <rect width="1440" height="1275" fill="#00968C" />;
          $[48] = t6;
        } else {
          t6 = $[48];
        }
        let t7;
        if ($[49] !== style) {
          t7 = <motion.circle opacity={0.4} cx="825" cy="639" r="252" fill="#00A399" style={style("center center")} />;
          $[49] = style;
          $[50] = t7;
        } else {
          t7 = $[50];
        }
        let t8;
        if ($[51] !== style) {
          t8 = <motion.rect opacity={0.65} x="573" y="-117" width="504" height="504" rx="40" fill="#00A399" style={style("top center")} />;
          $[51] = style;
          $[52] = t8;
        } else {
          t8 = $[52];
        }
        let t9;
        if ($[53] !== style) {
          t9 = <motion.path opacity={0.6} d="M252 1395C112.824 1395 -4.9317e-06 1282.18 -1.10153e-05 1143C-1.70988e-05 1003.82 112.824 891 252 891L1432 891C1454.09 891 1472 908.909 1472 931L1472 1355C1472 1377.09 1454.09 1395 1432 1395L252 1395Z" fill="#00A399" style={style("bottom center")} />;
          $[53] = style;
          $[54] = t9;
        } else {
          t9 = $[54];
        }
        let t10;
        if ($[55] !== style) {
          t10 = <motion.circle opacity={0.4} cx="1329" cy="135" r="252" fill="#00A399" style={style("top right")} />;
          $[55] = style;
          $[56] = t10;
        } else {
          t10 = $[56];
        }
        let t11;
        if ($[57] !== style) {
          t11 = <motion.rect opacity={0.65} x="1077" y="387" width="504" height="504" rx="40" fill="#00A399" style={style("center right")} />;
          $[57] = style;
          $[58] = t11;
        } else {
          t11 = $[58];
        }
        let t12;
        if ($[59] !== t10 || $[60] !== t11 || $[61] !== t5 || $[62] !== t7 || $[63] !== t8 || $[64] !== t9) {
          t12 = <g clipPath={t5}>{t6}{t7}{t8}{t9}{t10}{t11}</g>;
          $[59] = t10;
          $[60] = t11;
          $[61] = t5;
          $[62] = t7;
          $[63] = t8;
          $[64] = t9;
          $[65] = t12;
        } else {
          t12 = $[65];
        }
        let t13;
        if ($[66] !== t12 || $[67] !== t4) {
          t13 = <svg className="absolute inset-0 h-full w-full" viewBox="0 0 1440 1275" fill="none" preserveAspectRatio="xMidYMid slice" aria-hidden="true">{t4}{t12}</svg>;
          $[66] = t12;
          $[67] = t4;
          $[68] = t13;
        } else {
          t13 = $[68];
        }
        return t13;
      }
    case "peach":
      {
        const t2 = `${id}-peach`;
        let t3;
        if ($[69] === Symbol.for("react.memo_cache_sentinel")) {
          t3 = <rect width="1440" height="1275" fill="white" />;
          $[69] = t3;
        } else {
          t3 = $[69];
        }
        let t4;
        if ($[70] !== t2) {
          t4 = <defs><clipPath id={t2}>{t3}</clipPath></defs>;
          $[70] = t2;
          $[71] = t4;
        } else {
          t4 = $[71];
        }
        const t5 = `url(#${id}-peach)`;
        let t6;
        if ($[72] === Symbol.for("react.memo_cache_sentinel")) {
          t6 = <rect width="1440" height="1275" fill="#FFB497" />;
          $[72] = t6;
        } else {
          t6 = $[72];
        }
        let t7;
        if ($[73] !== style) {
          t7 = <motion.path opacity={0.7} d="M833.401 609H463V238.647C462.915 79.2207 592.153 -50 751.599 -50H1122V320.353C1122 479.779 992.763 609 833.316 609" fill="#FFAF8F" style={style("top center")} />;
          $[73] = style;
          $[74] = t7;
        } else {
          t7 = $[74];
        }
        let t8;
        if ($[75] !== style) {
          t8 = <motion.path opacity={0.7} d="M174.401 1322H-196V951.647C-196.085 792.221 -66.8474 663 92.599 663H463V1033.35C463 1192.78 333.763 1322 174.316 1322" fill="#FFAF8F" style={style("bottom left")} />;
          $[75] = style;
          $[76] = t8;
        } else {
          t8 = $[76];
        }
        let t9;
        if ($[77] !== style) {
          t9 = <motion.path opacity={0.7} d="M1410.16 613H1780V243.209C1780.08 84.0246 1651.04 -45 1491.84 -45H1122V324.791C1122 483.975 1251.04 613 1410.25 613" fill="#F8A98A" style={style("top right")} />;
          $[77] = style;
          $[78] = t9;
        } else {
          t9 = $[78];
        }
        let t10;
        if ($[79] !== style) {
          t10 = <motion.circle opacity={0.7} cx="792.5" cy="942.5" r="329.5" fill="#F8A98A" style={style("bottom center")} />;
          $[79] = style;
          $[80] = t10;
        } else {
          t10 = $[80];
        }
        let t11;
        if ($[81] !== style) {
          t11 = <motion.circle opacity={0.7} cx="1451.5" cy="942.5" r="329.5" fill="#FFAF8F" style={style("bottom right")} />;
          $[81] = style;
          $[82] = t11;
        } else {
          t11 = $[82];
        }
        let t12;
        if ($[83] !== t10 || $[84] !== t11 || $[85] !== t5 || $[86] !== t7 || $[87] !== t8 || $[88] !== t9) {
          t12 = <g clipPath={t5}>{t6}{t7}{t8}{t9}{t10}{t11}</g>;
          $[83] = t10;
          $[84] = t11;
          $[85] = t5;
          $[86] = t7;
          $[87] = t8;
          $[88] = t9;
          $[89] = t12;
        } else {
          t12 = $[89];
        }
        let t13;
        if ($[90] !== t12 || $[91] !== t4) {
          t13 = <svg className="absolute inset-0 h-full w-full" viewBox="0 0 1440 1275" fill="none" preserveAspectRatio="xMidYMid slice" aria-hidden="true">{t4}{t12}</svg>;
          $[90] = t12;
          $[91] = t4;
          $[92] = t13;
        } else {
          t13 = $[92];
        }
        return t13;
      }
    case "avocado":
      {
        const t2 = `${id}-avocado`;
        let t3;
        if ($[93] === Symbol.for("react.memo_cache_sentinel")) {
          t3 = <rect width="1440" height="1275" fill="white" />;
          $[93] = t3;
        } else {
          t3 = $[93];
        }
        let t4;
        if ($[94] !== t2) {
          t4 = <defs><clipPath id={t2}>{t3}</clipPath></defs>;
          $[94] = t2;
          $[95] = t4;
        } else {
          t4 = $[95];
        }
        const t5 = `url(#${id}-avocado)`;
        let t6;
        if ($[96] === Symbol.for("react.memo_cache_sentinel")) {
          t6 = <rect width="1440" height="1275" fill="#CCE88A" />;
          $[96] = t6;
        } else {
          t6 = $[96];
        }
        let t7;
        if ($[97] !== style) {
          t7 = <motion.path d="M1230.88 -183L740.882 307L1230.88 797L1720.88 307L1230.88 -183Z" fill="#C2E079" style={style("top right")} />;
          $[97] = style;
          $[98] = t7;
        } else {
          t7 = $[98];
        }
        let t8;
        if ($[99] !== style) {
          t8 = <motion.path d="M1230.88 537L740.882 1027L1230.88 1517L1720.88 1027L1230.88 537Z" fill="#C6E57D" style={style("bottom right")} />;
          $[99] = style;
          $[100] = t8;
        } else {
          t8 = $[100];
        }
        let t9;
        if ($[101] !== style) {
          t9 = <motion.path d="M777 -183L287 307L777 797L1267 307L777 -183Z" fill="#C6E57D" style={style("top left")} />;
          $[101] = style;
          $[102] = t9;
        } else {
          t9 = $[102];
        }
        let t10;
        if ($[103] !== style) {
          t10 = <motion.path d="M777 537L287 1027L777 1517L1267 1027L777 537Z" fill="#C2E079" style={style("bottom left")} />;
          $[103] = style;
          $[104] = t10;
        } else {
          t10 = $[104];
        }
        let t11;
        if ($[105] !== t10 || $[106] !== t5 || $[107] !== t7 || $[108] !== t8 || $[109] !== t9) {
          t11 = <g clipPath={t5}>{t6}{t7}{t8}{t9}{t10}</g>;
          $[105] = t10;
          $[106] = t5;
          $[107] = t7;
          $[108] = t8;
          $[109] = t9;
          $[110] = t11;
        } else {
          t11 = $[110];
        }
        let t12;
        if ($[111] !== t11 || $[112] !== t4) {
          t12 = <svg className="absolute inset-0 h-full w-full" viewBox="0 0 1440 1275" fill="none" preserveAspectRatio="xMidYMid slice" aria-hidden="true">{t4}{t11}</svg>;
          $[111] = t11;
          $[112] = t4;
          $[113] = t12;
        } else {
          t12 = $[113];
        }
        return t12;
      }
    case "sky-blue":
      {
        const t2 = `${id}-sky-blue`;
        let t3;
        if ($[114] === Symbol.for("react.memo_cache_sentinel")) {
          t3 = <rect width="1440" height="1275" fill="white" />;
          $[114] = t3;
        } else {
          t3 = $[114];
        }
        let t4;
        if ($[115] !== t2) {
          t4 = <defs><clipPath id={t2}>{t3}</clipPath></defs>;
          $[115] = t2;
          $[116] = t4;
        } else {
          t4 = $[116];
        }
        const t5 = `url(#${id}-sky-blue)`;
        let t6;
        if ($[117] === Symbol.for("react.memo_cache_sentinel")) {
          t6 = <rect width="1440" height="1275" fill="#A6B9F1" />;
          $[117] = t6;
        } else {
          t6 = $[117];
        }
        let t7;
        if ($[118] !== style) {
          t7 = <motion.path d="M833.401 609H463V238.647C462.915 79.2207 592.153 -50 751.599 -50H1122V320.353C1122 479.779 992.763 609 833.316 609" fill="#9BB1EF" style={style("top center")} />;
          $[118] = style;
          $[119] = t7;
        } else {
          t7 = $[119];
        }
        let t8;
        if ($[120] !== style) {
          t8 = <motion.path d="M174.401 1322H-196V951.647C-196.085 792.221 -66.8474 663 92.599 663H463V1033.35C463 1192.78 333.763 1322 174.316 1322" fill="#9BB1EF" style={style("bottom left")} />;
          $[120] = style;
          $[121] = t8;
        } else {
          t8 = $[121];
        }
        let t9;
        if ($[122] !== style) {
          t9 = <motion.path opacity={0.3} d="M1410.16 613H1780V243.209C1780.08 84.0246 1651.04 -45 1491.84 -45H1122V324.791C1122 483.975 1251.04 613 1410.25 613" fill="#90A7E7" style={style("top right")} />;
          $[122] = style;
          $[123] = t9;
        } else {
          t9 = $[123];
        }
        let t10;
        if ($[124] !== style) {
          t10 = <motion.circle opacity={0.3} cx="792.5" cy="942.5" r="329.5" fill="#90A7E7" style={style("bottom center")} />;
          $[124] = style;
          $[125] = t10;
        } else {
          t10 = $[125];
        }
        let t11;
        if ($[126] !== style) {
          t11 = <motion.circle cx="1451.5" cy="942.5" r="329.5" fill="#9BB1EF" style={style("bottom right")} />;
          $[126] = style;
          $[127] = t11;
        } else {
          t11 = $[127];
        }
        let t12;
        if ($[128] !== t10 || $[129] !== t11 || $[130] !== t5 || $[131] !== t7 || $[132] !== t8 || $[133] !== t9) {
          t12 = <g clipPath={t5}>{t6}{t7}{t8}{t9}{t10}{t11}</g>;
          $[128] = t10;
          $[129] = t11;
          $[130] = t5;
          $[131] = t7;
          $[132] = t8;
          $[133] = t9;
          $[134] = t12;
        } else {
          t12 = $[134];
        }
        let t13;
        if ($[135] !== t12 || $[136] !== t4) {
          t13 = <svg className="absolute inset-0 h-full w-full" viewBox="0 0 1440 1275" fill="none" preserveAspectRatio="xMidYMid slice" aria-hidden="true">{t4}{t12}</svg>;
          $[135] = t12;
          $[136] = t4;
          $[137] = t13;
        } else {
          t13 = $[137];
        }
        return t13;
      }
    case "orange":
      {
        const t2 = `${id}-orange`;
        let t3;
        if ($[138] === Symbol.for("react.memo_cache_sentinel")) {
          t3 = <rect width="1440" height="1275" fill="white" />;
          $[138] = t3;
        } else {
          t3 = $[138];
        }
        let t4;
        if ($[139] !== t2) {
          t4 = <defs><clipPath id={t2}>{t3}</clipPath></defs>;
          $[139] = t2;
          $[140] = t4;
        } else {
          t4 = $[140];
        }
        const t5 = `url(#${id}-orange)`;
        let t6;
        if ($[141] === Symbol.for("react.memo_cache_sentinel")) {
          t6 = <rect width="1440" height="1275" fill="#F0B464" />;
          $[141] = t6;
        } else {
          t6 = $[141];
        }
        let t7;
        if ($[142] !== style) {
          t7 = <motion.path opacity={0.7} d="M1542 1298.5C1542 1302.92 1538.42 1306.5 1534 1306.5H909C904.582 1306.5 901 1302.92 901 1298.5V682.959C901 506.211 1044.52 363 1221.46 363C1398.4 363 1542 506.293 1542 682.959V1298.5Z" fill="#EFAC53" style={style("bottom right")} />;
          $[142] = style;
          $[143] = t7;
        } else {
          t7 = $[143];
        }
        let t8;
        if ($[144] !== style) {
          t8 = <motion.path opacity={0.4} d="M-58.5 958C-62.9183 958 -66.5 954.418 -66.5 950L-66.5 325C-66.5 320.582 -62.9183 317 -58.5 317L580.541 317C757.289 317 900.5 460.517 900.5 637.459C900.5 814.4 757.207 958 580.541 958L-58.5 958Z" fill="#EFAC53" style={style("center left")} />;
          $[144] = style;
          $[145] = t8;
        } else {
          t8 = $[145];
        }
        let t9;
        if ($[146] !== style) {
          t9 = <motion.path opacity={0.7} d="M-58.5 1599C-62.9183 1599 -66.5 1595.42 -66.5 1591L-66.5 966C-66.5 961.582 -62.9183 958 -58.5 958L580.541 958C757.289 958 900.5 1101.52 900.5 1278.46C900.5 1455.4 757.207 1599 580.541 1599L-58.5 1599Z" fill="#EFAC53" style={style("bottom left")} />;
          $[146] = style;
          $[147] = t9;
        } else {
          t9 = $[147];
        }
        let t10;
        if ($[148] !== style) {
          t10 = <motion.path opacity={0.7} d="M622 -207C622 -211.418 625.582 -215 630 -215L1255 -215C1259.42 -215 1263 -211.418 1263 -207L1263 105.541C1263 282.565 1119.48 426 942.541 426C765.6 426 622 282.483 622 105.541L622 -207Z" fill="#EFAC53" style={style("top right")} />;
          $[148] = style;
          $[149] = t10;
        } else {
          t10 = $[149];
        }
        let t11;
        if ($[150] !== t10 || $[151] !== t5 || $[152] !== t7 || $[153] !== t8 || $[154] !== t9) {
          t11 = <g clipPath={t5}>{t6}{t7}{t8}{t9}{t10}</g>;
          $[150] = t10;
          $[151] = t5;
          $[152] = t7;
          $[153] = t8;
          $[154] = t9;
          $[155] = t11;
        } else {
          t11 = $[155];
        }
        let t12;
        if ($[156] !== t11 || $[157] !== t4) {
          t12 = <svg className="absolute inset-0 h-full w-full" viewBox="0 0 1440 1275" fill="none" preserveAspectRatio="xMidYMid slice" aria-hidden="true">{t4}{t11}</svg>;
          $[156] = t11;
          $[157] = t4;
          $[158] = t12;
        } else {
          t12 = $[158];
        }
        return t12;
      }
    case "sea":
      {
        const t2 = `${id}-sea`;
        let t3;
        if ($[159] === Symbol.for("react.memo_cache_sentinel")) {
          t3 = <rect width="1440" height="1275" fill="white" />;
          $[159] = t3;
        } else {
          t3 = $[159];
        }
        let t4;
        if ($[160] !== t2) {
          t4 = <defs><clipPath id={t2}>{t3}</clipPath></defs>;
          $[160] = t2;
          $[161] = t4;
        } else {
          t4 = $[161];
        }
        const t5 = `url(#${id}-sea)`;
        let t6;
        if ($[162] === Symbol.for("react.memo_cache_sentinel")) {
          t6 = <rect width="1440" height="1275" fill="#007190" />;
          $[162] = t6;
        } else {
          t6 = $[162];
        }
        let t7;
        if ($[163] !== style) {
          t7 = <motion.path opacity={0.7} d="M1542 1321H901V682.959C901 506.211 1044.52 363 1221.46 363C1398.4 363 1542 506.293 1542 682.959V1321Z" fill="#008AAA" style={style("bottom right")} />;
          $[163] = style;
          $[164] = t7;
        } else {
          t7 = $[164];
        }
        let t8;
        if ($[165] !== style) {
          t8 = <motion.path opacity={0.4} d="M-66.5 958L-66.5 317L580.541 317C757.289 317 900.5 460.517 900.5 637.459C900.5 814.4 757.207 958 580.541 958L-66.5 958Z" fill="#008AAA" style={style("center left")} />;
          $[165] = style;
          $[166] = t8;
        } else {
          t8 = $[166];
        }
        let t9;
        if ($[167] !== style) {
          t9 = <motion.path opacity={0.4} d="M-66.5 1599L-66.5 958L580.541 958C757.289 958 900.5 1101.52 900.5 1278.46C900.5 1455.4 757.207 1599 580.541 1599L-66.5 1599Z" fill="#008AAA" style={style("bottom left")} />;
          $[167] = style;
          $[168] = t9;
        } else {
          t9 = $[168];
        }
        let t10;
        if ($[169] !== style) {
          t10 = <motion.path opacity={0.7} d="M622 -215L1263 -215L1263 105.541C1263 282.565 1119.48 426 942.541 426C765.6 426 622 282.483 622 105.541L622 -215Z" fill="#008AAA" style={style("top right")} />;
          $[169] = style;
          $[170] = t10;
        } else {
          t10 = $[170];
        }
        let t11;
        if ($[171] !== t10 || $[172] !== t5 || $[173] !== t7 || $[174] !== t8 || $[175] !== t9) {
          t11 = <g clipPath={t5}>{t6}{t7}{t8}{t9}{t10}</g>;
          $[171] = t10;
          $[172] = t5;
          $[173] = t7;
          $[174] = t8;
          $[175] = t9;
          $[176] = t11;
        } else {
          t11 = $[176];
        }
        let t12;
        if ($[177] !== t11 || $[178] !== t4) {
          t12 = <svg className="absolute inset-0 h-full w-full" viewBox="0 0 1440 1275" fill="none" preserveAspectRatio="xMidYMid slice" aria-hidden="true">{t4}{t11}</svg>;
          $[177] = t11;
          $[178] = t4;
          $[179] = t12;
        } else {
          t12 = $[179];
        }
        return t12;
      }
    case "mint":
      {
        const t2 = `${id}-mint`;
        let t3;
        if ($[180] === Symbol.for("react.memo_cache_sentinel")) {
          t3 = <rect width="1440" height="1275" fill="white" />;
          $[180] = t3;
        } else {
          t3 = $[180];
        }
        let t4;
        if ($[181] !== t2) {
          t4 = <defs><clipPath id={t2}>{t3}</clipPath></defs>;
          $[181] = t2;
          $[182] = t4;
        } else {
          t4 = $[182];
        }
        const t5 = `url(#${id}-mint)`;
        let t6;
        if ($[183] === Symbol.for("react.memo_cache_sentinel")) {
          t6 = <rect width="1440" height="1275" fill="#86CD9F" />;
          $[183] = t6;
        } else {
          t6 = $[183];
        }
        let t7;
        if ($[184] !== style) {
          t7 = <motion.path opacity={0.5} d="M868.767 631H486V248.283C485.912 83.5346 619.464 -50 784.234 -50H1167V332.717C1167 497.466 1033.45 631 868.679 631" fill="#6EC18B" style={style("top center")} />;
          $[184] = style;
          $[185] = t7;
        } else {
          t7 = $[185];
        }
        let t8;
        if ($[186] !== style) {
          t8 = <motion.path opacity={0.5} d="M187.329 1368H-196V984.721C-196.088 819.731 -62.3398 686 102.671 686H486V1069.28C486 1234.27 352.252 1368 187.241 1368" fill="#6EC18B" style={style("bottom left")} />;
          $[186] = style;
          $[187] = t8;
        } else {
          t8 = $[187];
        }
        let t9;
        if ($[188] !== style) {
          t9 = <motion.path d="M1465.23 635H1848V252.845C1848.09 88.3385 1714.54 -45 1549.77 -45H1167V337.155C1167 501.662 1300.55 635 1465.32 635" fill="#6EC18B" style={style("top right")} />;
          $[188] = style;
          $[189] = t9;
        } else {
          t9 = $[189];
        }
        let t10;
        if ($[190] !== style) {
          t10 = <motion.circle cx="826.5" cy="975.5" r="340.5" fill="#6EC18B" style={style("bottom center")} />;
          $[190] = style;
          $[191] = t10;
        } else {
          t10 = $[191];
        }
        let t11;
        if ($[192] !== style) {
          t11 = <motion.ellipse opacity={0.5} cx="1508" cy="975.5" rx="341" ry="340.5" fill="#6EC18B" style={style("bottom right")} />;
          $[192] = style;
          $[193] = t11;
        } else {
          t11 = $[193];
        }
        let t12;
        if ($[194] !== t10 || $[195] !== t11 || $[196] !== t5 || $[197] !== t7 || $[198] !== t8 || $[199] !== t9) {
          t12 = <g clipPath={t5}>{t6}{t7}{t8}{t9}{t10}{t11}</g>;
          $[194] = t10;
          $[195] = t11;
          $[196] = t5;
          $[197] = t7;
          $[198] = t8;
          $[199] = t9;
          $[200] = t12;
        } else {
          t12 = $[200];
        }
        let t13;
        if ($[201] !== t12 || $[202] !== t4) {
          t13 = <svg className="absolute inset-0 h-full w-full" viewBox="0 0 1440 1275" fill="none" preserveAspectRatio="xMidYMid slice" aria-hidden="true">{t4}{t12}</svg>;
          $[201] = t12;
          $[202] = t4;
          $[203] = t13;
        } else {
          t13 = $[203];
        }
        return t13;
      }
    case "yellow":
      {
        const t2 = `${id}-yellow`;
        let t3;
        if ($[204] === Symbol.for("react.memo_cache_sentinel")) {
          t3 = <rect width="1440" height="1275" fill="white" />;
          $[204] = t3;
        } else {
          t3 = $[204];
        }
        let t4;
        if ($[205] !== t2) {
          t4 = <defs><clipPath id={t2}>{t3}</clipPath></defs>;
          $[205] = t2;
          $[206] = t4;
        } else {
          t4 = $[206];
        }
        const t5 = `url(#${id}-yellow)`;
        let t6;
        if ($[207] === Symbol.for("react.memo_cache_sentinel")) {
          t6 = <rect width="1440" height="1275" fill="#FFD152" />;
          $[207] = t6;
        } else {
          t6 = $[207];
        }
        let t7;
        if ($[208] !== style) {
          t7 = <motion.path opacity={0.6} d="M1230.88 -212L740.882 278L1230.88 768L1720.88 278L1230.88 -212Z" fill="#FFC83D" style={style("top right")} />;
          $[208] = style;
          $[209] = t7;
        } else {
          t7 = $[209];
        }
        let t8;
        if ($[210] !== style) {
          t8 = <motion.path d="M1230.88 508L740.882 998L1230.88 1488L1720.88 998L1230.88 508Z" fill="#FFD555" style={style("bottom right")} />;
          $[210] = style;
          $[211] = t8;
        } else {
          t8 = $[211];
        }
        let t9;
        if ($[212] !== style) {
          t9 = <motion.path d="M777 -212L287 278L777 768L1267 278L777 -212Z" fill="#FFD555" style={style("top left")} />;
          $[212] = style;
          $[213] = t9;
        } else {
          t9 = $[213];
        }
        let t10;
        if ($[214] !== style) {
          t10 = <motion.path opacity={0.6} d="M777 508L287 998L777 1488L1267 998L777 508Z" fill="#FFC83D" style={style("bottom left")} />;
          $[214] = style;
          $[215] = t10;
        } else {
          t10 = $[215];
        }
        let t11;
        if ($[216] !== t10 || $[217] !== t5 || $[218] !== t7 || $[219] !== t8 || $[220] !== t9) {
          t11 = <g clipPath={t5}>{t6}{t7}{t8}{t9}{t10}</g>;
          $[216] = t10;
          $[217] = t5;
          $[218] = t7;
          $[219] = t8;
          $[220] = t9;
          $[221] = t11;
        } else {
          t11 = $[221];
        }
        let t12;
        if ($[222] !== t11 || $[223] !== t4) {
          t12 = <svg className="absolute inset-0 h-full w-full" viewBox="0 0 1440 1275" fill="none" preserveAspectRatio="xMidYMid slice" aria-hidden="true">{t4}{t11}</svg>;
          $[222] = t11;
          $[223] = t4;
          $[224] = t12;
        } else {
          t12 = $[224];
        }
        return t12;
      }
    case "cobalt":
      {
        const t2 = `${id}-cobalt`;
        let t3;
        if ($[225] === Symbol.for("react.memo_cache_sentinel")) {
          t3 = <rect width="1440" height="1275" fill="white" />;
          $[225] = t3;
        } else {
          t3 = $[225];
        }
        let t4;
        if ($[226] !== t2) {
          t4 = <defs><clipPath id={t2}>{t3}</clipPath></defs>;
          $[226] = t2;
          $[227] = t4;
        } else {
          t4 = $[227];
        }
        const t5 = `url(#${id}-cobalt)`;
        let t6;
        if ($[228] === Symbol.for("react.memo_cache_sentinel")) {
          t6 = <rect width="1440" height="1275" fill="#2B52B8" />;
          $[228] = t6;
        } else {
          t6 = $[228];
        }
        let t7;
        if ($[229] !== style) {
          t7 = <motion.path opacity={0.4} d="M1542 1307C1542 1311.42 1538.42 1315 1534 1315H909C904.582 1315 901 1311.42 901 1307V682.959C901 506.211 1044.52 363 1221.46 363C1398.4 363 1542 506.293 1542 682.959V1307Z" fill="#2F5FD6" style={style("bottom right")} />;
          $[229] = style;
          $[230] = t7;
        } else {
          t7 = $[230];
        }
        let t8;
        if ($[231] !== style) {
          t8 = <motion.path opacity={0.7} d="M-58.5 958C-62.9183 958 -66.5 954.418 -66.5 950L-66.5 325C-66.5 320.582 -62.9183 317 -58.5 317L580.541 317C757.289 317 900.5 460.517 900.5 637.459C900.5 814.4 757.207 958 580.541 958L-58.5 958Z" fill="#2F5FD6" style={style("center left")} />;
          $[231] = style;
          $[232] = t8;
        } else {
          t8 = $[232];
        }
        let t9;
        if ($[233] !== style) {
          t9 = <motion.path opacity={0.4} d="M-58.5 1599C-62.9183 1599 -66.5 1595.42 -66.5 1591L-66.5 966C-66.5 961.582 -62.9183 958 -58.5 958L580.541 958C757.289 958 900.5 1101.52 900.5 1278.46C900.5 1455.4 757.207 1599 580.541 1599L-58.5 1599Z" fill="#2F5FD6" style={style("bottom left")} />;
          $[233] = style;
          $[234] = t9;
        } else {
          t9 = $[234];
        }
        let t10;
        if ($[235] !== style) {
          t10 = <motion.path opacity={0.7} d="M622 -207C622 -211.418 625.582 -215 630 -215L1255 -215C1259.42 -215 1263 -211.418 1263 -207L1263 105.541C1263 282.565 1119.48 426 942.541 426C765.6 426 622 282.483 622 105.541L622 -207Z" fill="#2F5FD6" style={style("top right")} />;
          $[235] = style;
          $[236] = t10;
        } else {
          t10 = $[236];
        }
        let t11;
        if ($[237] !== t10 || $[238] !== t5 || $[239] !== t7 || $[240] !== t8 || $[241] !== t9) {
          t11 = <g clipPath={t5}>{t6}{t7}{t8}{t9}{t10}</g>;
          $[237] = t10;
          $[238] = t5;
          $[239] = t7;
          $[240] = t8;
          $[241] = t9;
          $[242] = t11;
        } else {
          t11 = $[242];
        }
        let t12;
        if ($[243] !== t11 || $[244] !== t4) {
          t12 = <svg className="absolute inset-0 h-full w-full" viewBox="0 0 1440 1275" fill="none" preserveAspectRatio="xMidYMid slice" aria-hidden="true">{t4}{t11}</svg>;
          $[243] = t11;
          $[244] = t4;
          $[245] = t12;
        } else {
          t12 = $[245];
        }
        return t12;
      }
    case "ocean":
      {
        const t2 = `${id}-ocean`;
        let t3;
        if ($[246] === Symbol.for("react.memo_cache_sentinel")) {
          t3 = <rect width="1440" height="1275" fill="white" />;
          $[246] = t3;
        } else {
          t3 = $[246];
        }
        let t4;
        if ($[247] !== t2) {
          t4 = <defs><clipPath id={t2}>{t3}</clipPath></defs>;
          $[247] = t2;
          $[248] = t4;
        } else {
          t4 = $[248];
        }
        const t5 = `url(#${id}-ocean)`;
        let t6;
        if ($[249] === Symbol.for("react.memo_cache_sentinel")) {
          t6 = <rect width="1440" height="1275" fill="#1A3C82" />;
          $[249] = t6;
        } else {
          t6 = $[249];
        }
        let t7;
        if ($[250] !== style) {
          t7 = <motion.path d="M800.329 634H417V250.721C416.912 85.7306 550.66 -48 715.671 -48H1099V335.279C1099 500.269 965.252 634 800.241 634" fill="#284A94" style={style("top center")} />;
          $[250] = style;
          $[251] = t7;
        } else {
          t7 = $[251];
        }
        let t8;
        if ($[252] !== style) {
          t8 = <motion.path opacity={0.6} d="M118.329 1368H-265V984.721C-265.088 819.731 -131.34 686 33.6715 686H417V1069.28C417 1234.27 283.252 1368 118.241 1368" fill="#284A94" style={style("bottom left")} />;
          $[252] = style;
          $[253] = t8;
        } else {
          t8 = $[253];
        }
        let t9;
        if ($[254] !== style) {
          t9 = <motion.path opacity={0.4} d="M1397.23 638H1780V255.283C1780.09 90.5346 1646.54 -43 1481.77 -43H1099V339.717C1099 504.466 1232.55 638 1397.32 638" fill="#284A94" style={style("top right")} />;
          $[254] = style;
          $[255] = t9;
        } else {
          t9 = $[255];
        }
        let t10;
        if ($[256] !== style) {
          t10 = <motion.circle opacity={0.56} cx="758" cy="975" r="341" fill="#284A94" style={style("bottom center")} />;
          $[256] = style;
          $[257] = t10;
        } else {
          t10 = $[257];
        }
        let t11;
        if ($[258] !== style) {
          t11 = <motion.circle cx="1440" cy="975" r="341" fill="#284A94" style={style("bottom right")} />;
          $[258] = style;
          $[259] = t11;
        } else {
          t11 = $[259];
        }
        let t12;
        if ($[260] !== t10 || $[261] !== t11 || $[262] !== t5 || $[263] !== t7 || $[264] !== t8 || $[265] !== t9) {
          t12 = <g clipPath={t5}>{t6}{t7}{t8}{t9}{t10}{t11}</g>;
          $[260] = t10;
          $[261] = t11;
          $[262] = t5;
          $[263] = t7;
          $[264] = t8;
          $[265] = t9;
          $[266] = t12;
        } else {
          t12 = $[266];
        }
        let t13;
        if ($[267] !== t12 || $[268] !== t4) {
          t13 = <svg className="absolute inset-0 h-full w-full" viewBox="0 0 1440 1275" fill="none" preserveAspectRatio="xMidYMid slice" aria-hidden="true">{t4}{t12}</svg>;
          $[267] = t12;
          $[268] = t4;
          $[269] = t13;
        } else {
          t13 = $[269];
        }
        return t13;
      }
    default:
      {
        return null;
      }
  }
}
const RectangleXlColorBlock = React.forwardRef<HTMLDivElement, VariantProps>((t0, ref) => {
  const $ = _c(26);
  let children;
  let className;
  let props;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      color: t1,
      animated: t2,
      children,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
    $[4] = t1;
    $[5] = t2;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
    t1 = $[4];
    t2 = $[5];
  }
  const color = t1 === undefined ? "bright-blue" : t1;
  const animated = t2 === undefined ? true : t2;
  const containerRef = useRef(null);
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      target: containerRef,
      offset: ["start end", "end start"]
    };
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const {
    scrollYProgress
  } = useScroll(t3);
  let t4;
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = [0, 1];
    t5 = [1, 1.3];
    $[7] = t4;
    $[8] = t5;
  } else {
    t4 = $[7];
    t5 = $[8];
  }
  const shapeScale = useTransform(scrollYProgress, t4, t5);
  let t6;
  if ($[9] !== ref) {
    t6 = node => {
      (containerRef as React.MutableRefObject<HTMLDivElement | null>).current = node;
      if (typeof ref === "function") {
        ref(node);
      } else {
        if (ref) {
          ref.current = node;
        }
      }
    };
    $[9] = ref;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const t7 = !children && "aspect-[96/85]";
  let t8;
  if ($[11] !== className || $[12] !== t7) {
    t8 = cn("relative overflow-hidden", t7, className);
    $[11] = className;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== animated || $[15] !== color || $[16] !== shapeScale) {
    t9 = <RectangleXlSvg color={color} animated={animated} shapeScale={shapeScale} />;
    $[14] = animated;
    $[15] = color;
    $[16] = shapeScale;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== children) {
    t10 = children && <div className="relative z-10">{children}</div>;
    $[18] = children;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== props || $[21] !== t10 || $[22] !== t6 || $[23] !== t8 || $[24] !== t9) {
    t11 = <div ref={t6} data-slot="color-block" className={t8} {...props}>{t9}{t10}</div>;
    $[20] = props;
    $[21] = t10;
    $[22] = t6;
    $[23] = t8;
    $[24] = t9;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  return t11;
});
RectangleXlColorBlock.displayName = "RectangleXlColorBlock";
export { RectangleXlColorBlock };